/* tslint:disable */
/* eslint-disable */
/**
 * Performo API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.5.25
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { JobRankFromJSON, JobRankToJSON, } from './';
export function WorkerFromJSON(json) {
    return WorkerFromJSONTyped(json, false);
}
export function WorkerFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'fmRecordId': !exists(json, 'fmRecordId') ? undefined : json['fmRecordId'],
        'fmModId': !exists(json, 'fmModId') ? undefined : json['fmModId'],
        'workerId': !exists(json, 'workerId') ? undefined : json['workerId'],
        'secureLaborId': !exists(json, 'secureLaborId') ? undefined : json['secureLaborId'],
        'propertyId': !exists(json, 'propertyId') ? undefined : json['propertyId'],
        'workerName': !exists(json, 'workerName') ? undefined : json['workerName'],
        'hourlyRate': !exists(json, 'hourlyRate') ? undefined : json['hourlyRate'],
        'workerNotifyPref': !exists(json, 'workerNotifyPref') ? undefined : json['workerNotifyPref'],
        'workerNotes': !exists(json, 'workerNotes') ? undefined : json['workerNotes'],
        'emailAddress': !exists(json, 'emailAddress') ? undefined : json['emailAddress'],
        'phone': !exists(json, 'phone') ? undefined : json['phone'],
        'cellphone': !exists(json, 'cellphone') ? undefined : json['cellphone'],
        'vendorId': !exists(json, 'vendorId') ? undefined : json['vendorId'],
        'vendorName': !exists(json, 'vendorName') ? undefined : json['vendorName'],
        'contact1Flag': !exists(json, 'contact1Flag') ? undefined : json['contact1Flag'],
        'masterRecordFlag': !exists(json, 'masterRecordFlag') ? undefined : json['masterRecordFlag'],
        'workerPersonnelId': !exists(json, 'workerPersonnelId') ? undefined : json['workerPersonnelId'],
        'supervisorFlag': !exists(json, 'supervisorFlag') ? undefined : json['supervisorFlag'],
        'shifts': !exists(json, 'shifts') ? undefined : json['shifts'],
        'buildings': !exists(json, 'buildings') ? undefined : json['buildings'],
        'pager': !exists(json, 'pager') ? undefined : json['pager'],
        'inOut': !exists(json, 'inOut') ? undefined : json['inOut'],
        'userNameEntry': !exists(json, 'userNameEntry') ? undefined : json['userNameEntry'],
        'roleEntry': !exists(json, 'roleEntry') ? undefined : json['roleEntry'],
        'locationTrackingFlag': !exists(json, 'locationTrackingFlag') ? undefined : json['locationTrackingFlag'],
        'locationTrackingDeviceNumber': !exists(json, 'locationTrackingDeviceNumber') ? undefined : json['locationTrackingDeviceNumber'],
        'includeDailyReportFlag': !exists(json, 'includeDailyReportFlag') ? undefined : json['includeDailyReportFlag'],
        'workerReAssignKey': !exists(json, 'workerReAssignKey') ? undefined : json['workerReAssignKey'],
        'createdDate': !exists(json, 'createdDate') ? undefined : (new Date(json['createdDate'])),
        'createdTime': !exists(json, 'createdTime') ? undefined : json['createdTime'],
        'createdBy': !exists(json, 'createdBy') ? undefined : json['createdBy'],
        'modifiedDate': !exists(json, 'modifiedDate') ? undefined : (new Date(json['modifiedDate'])),
        'modifiedTime': !exists(json, 'modifiedTime') ? undefined : json['modifiedTime'],
        'modifiedBy': !exists(json, 'modifiedBy') ? undefined : json['modifiedBy'],
        'createdTimestamp': !exists(json, 'createdTimestamp') ? undefined : (new Date(json['createdTimestamp'])),
        'modifiedTimestamp': !exists(json, 'modifiedTimestamp') ? undefined : (new Date(json['modifiedTimestamp'])),
        'jobRanks': !exists(json, 'jobRanks') ? undefined : (json['jobRanks'] === null ? null : json['jobRanks'].map(JobRankFromJSON)),
        'tradeDisplay': !exists(json, 'tradeDisplay') ? undefined : json['tradeDisplay'],
        'workerTrades': !exists(json, 'workerTrades') ? undefined : json['workerTrades'],
        'trades': !exists(json, 'trades') ? undefined : json['trades'],
    };
}
export function WorkerToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'fmRecordId': value.fmRecordId,
        'fmModId': value.fmModId,
        'workerId': value.workerId,
        'secureLaborId': value.secureLaborId,
        'propertyId': value.propertyId,
        'workerName': value.workerName,
        'hourlyRate': value.hourlyRate,
        'workerNotifyPref': value.workerNotifyPref,
        'workerNotes': value.workerNotes,
        'emailAddress': value.emailAddress,
        'phone': value.phone,
        'cellphone': value.cellphone,
        'vendorId': value.vendorId,
        'vendorName': value.vendorName,
        'contact1Flag': value.contact1Flag,
        'masterRecordFlag': value.masterRecordFlag,
        'workerPersonnelId': value.workerPersonnelId,
        'supervisorFlag': value.supervisorFlag,
        'shifts': value.shifts,
        'buildings': value.buildings,
        'pager': value.pager,
        'inOut': value.inOut,
        'userNameEntry': value.userNameEntry,
        'roleEntry': value.roleEntry,
        'locationTrackingFlag': value.locationTrackingFlag,
        'locationTrackingDeviceNumber': value.locationTrackingDeviceNumber,
        'includeDailyReportFlag': value.includeDailyReportFlag,
        'workerReAssignKey': value.workerReAssignKey,
        'createdDate': value.createdDate === undefined ? undefined : (value.createdDate.toISOString()),
        'createdTime': value.createdTime,
        'createdBy': value.createdBy,
        'modifiedDate': value.modifiedDate === undefined ? undefined : (value.modifiedDate.toISOString()),
        'modifiedTime': value.modifiedTime,
        'modifiedBy': value.modifiedBy,
        'createdTimestamp': value.createdTimestamp === undefined ? undefined : (value.createdTimestamp.toISOString()),
        'modifiedTimestamp': value.modifiedTimestamp === undefined ? undefined : (value.modifiedTimestamp.toISOString()),
        'jobRanks': value.jobRanks === undefined ? undefined : (value.jobRanks === null ? null : value.jobRanks.map(JobRankToJSON)),
        'tradeDisplay': value.tradeDisplay,
        'trades': value.trades,
    };
}
